import React,{useMemo,useState} from 'react';
import {FiPlus,FiSearch,FiFilm} from 'react-icons/fi';
import Dialog from './Dialog';
import MediaThumbnail from './MediaThumbnail';

export default function MediaLibraryPicker({assets=[],projectInterviews=[],busy=false,onClose,onUse,getUrl}) {
 const [query,setQuery]=useState('');
 const search=query.trim().toLowerCase();
 const used=useMemo(()=>new Set(projectInterviews.map(row=>row.media_path)),[projectInterviews]);
 const available=assets.filter(asset=>[asset.data?.title,asset.data?.filename,asset.data?.displayName]
  .some(value=>(value||'').toLowerCase().includes(search)));
 return <Dialog title="Add from Media Library" className="media-library-dialog" onClose={onClose}>
  <p className="media-library-dialog-intro">Use an interview you've already uploaded. The video and transcript are reused without another upload; edits in this project remain independent.</p>
  <label className="media-library-modal-search"><FiSearch aria-hidden="true"/><input aria-label="Search library videos" placeholder="Search your uploaded videos…" value={query} onChange={e=>setQuery(e.target.value)}/></label>
  <div className="media-library-modal-results">
   {available.map(asset=>{
    const existing=used.has(asset.media_path);
    return <div className="media-library-modal-row" key={asset.id}>
      <MediaThumbnail row={{...asset,media_ready:true}} getUrl={getUrl}/>
      <div><strong>{asset.data?.filename||asset.data?.title||'Unnamed video'}</strong>
        <small>{asset.data?.words?.length?`${asset.data.words.length.toLocaleString()} transcript words`:'Ready to transcribe'}</small></div>
      <button type="button" onClick={()=>onUse(asset.id)} disabled={busy||existing}
       title={existing?'Already in this project':'Reuse video in this project'}>
        {existing?'Added':<><FiPlus/> Add</>}
      </button>
    </div>;
   })}
   {!available.length&&<div className="media-library-modal-empty"><FiFilm/><p>{query?'No matches in your library.':'Your uploaded interviews will appear here automatically.'}</p></div>}
  </div>
 </Dialog>;
}
